import _defineProperty from "@babel/runtime/helpers/defineProperty";
import AnalyticsWebClient, { originType } from '@atlassiansox/analytics-web-client';
import { isEmceeConnect } from '../utils/package-connect-utils';
const STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
class AnalyticsClient {
  static init(config, hostConfig, hostInfo) {
    if (this._client) {
      return this._client;
    }
    const origin = navigator.userAgent.includes('Electron/') ? originType.DESKTOP : originType.WEB;
    const analyticsWebClientUrl = new URL(STARGATE_PROXY_PATH, hostInfo.baseUrl);
    this._client = new AnalyticsWebClient({
      env: config.analytics.productAnalytics.env,
      product: hostConfig.analytics.productName,
      subproduct: hostConfig.analytics.getSubproduct(hostInfo.subproduct),
      origin
    }, {
      useLegacyUrl: config.analytics.productAnalytics.env === 'local' || config.analytics.productAnalytics.env === 'dev',
      /*  RequestURL for GASv3 events is set using window.location.host by default in '@atlassiansox/analytics-web-client'
          This won't work for Emcee Connect as window.location.host doesn't give you the actual hostname.
          apiHost property is passed to override the default behaviour
      */apiHost: isEmceeConnect() ? analyticsWebClientUrl.host + analyticsWebClientUrl.pathname : null
    });
  }
  static get() {
    if (this._client) {
      return this._client;
    }
    throw new Error('Analytics client should be initialised before it is fetched!');
  }
}
_defineProperty(AnalyticsClient, "_client", null);
export default AnalyticsClient;